import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import IncomeExpenceTable from './IncomeExpenceTable'
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import breadcrumbs from "../../../common/Breadcrumbs"
import { useLocation } from 'react-router-dom'
import { dateFormat } from 'pages/Common'
import useApi from 'common/ApiMiddlewere'
import Select, { components } from "react-select";
import { toast } from 'react-hot-toast'
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

const InputOption = ({
    getStyles,
    Icon,
    isDisabled,
    isFocused,
    isSelected,
    children,
    innerProps,
    ...rest
}) => {
    const [isActive, setIsActive] = useState(false);
    const onMouseDown = () => setIsActive(true);
    const onMouseUp = () => setIsActive(false);
    const onMouseLeave = () => setIsActive(false);

    // styles
    let bg = "transparent";
    if (isFocused) bg = "#eee";
    if (isActive) bg = "#B2D4FF";

    const borderRadius = "1px";

    const style = {
        alignItems: "center",
        backgroundColor: bg,
        color: "inherit",
        display: "flex",
        borderRadius: borderRadius,
    };

    const props = {
        ...innerProps,
        onMouseDown,
        onMouseUp,
        onMouseLeave,
        style,
    };

    return (
        <components.Option
            {...rest}
            isDisabled={isDisabled}
            isFocused={isFocused}
            isSelected={isSelected}
            getStyles={getStyles}
            innerProps={props}
        >
            <div className='mt-2 m-1'>
                <input type="checkbox" checked={isSelected} />
            </div>
            {children}
        </components.Option>
    );
};

const allOptions = [
    { value: "Name", label: "Name" },
    { value: "Details", label: "Details" },
    { value: "Mode", label: "Mode" },
];

const selectStyles = {
    control: (provided, { isFocused }) => (
        {
            label: "control",
            alignItems: "center",
            cursor: "default",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            minHeight: 38,
            outline: "0 !important",
            position: "relative",
            transition: "all 100ms",
            backgroundColor: "hsl(0, 0%, 100%)",
            borderColor: "hsl(0, 0%, 80%)",
            borderRadius: 1,
            borderStyle: "solid",
            borderWidth: 1,
            '&:hover': {
                borderColor: "none",
            },
            boxSizing: "border-box",
        }
    ),
    placeholder: (provided) => ({
        ...provided,
        color: "gray",
    }),
};

const IncomExpense = () => {
    document.title = `IncomeExpense | ${localStorage.getItem("ShopName")}`
    let { pathname } = useLocation()
    const { postApi } = useApi()
    const flatpickrRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadiButtonng, setIsButtonLoading] = useState(false)
    const [isMobile, setisMobile] = useState(window.innerWidth < 520)
    const [isIpad, setisIpad] = useState(window.innerWidth >= 520 && window.innerWidth < 769);
    const [totalIncome, setTotalIncome] = useState()
    const [totalExpense, setTotalExpense] = useState()
    const [IncomeData, setIncomeData] = useState([])
    const [selectedOptions, setSelectedOptions] = useState([])
    const [date, setdate] = useState([new Date(), new Date()])

    const incomeExoenseApi = () => {
        if (date[1] == undefined) {
            toast("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        }
        else {
            setIsButtonLoading(true)
            postApi("Report/income-expense-report", {
                fromDate: date[0] ? dateFormat(
                    date[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: date[1] ? dateFormat(
                    date[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
            }).then(({ data, status }) => {
                if (status === 200) {
                    setIncomeData(data?.IncomeExpenseCombineList)
                    setTotalIncome(data?.TotalIncome)
                    setTotalExpense(data?.TotalExpenses)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsButtonLoading(false)
            })
        }
    }

    useEffect(() => {
        incomeExoenseApi()
    }, [])

    const handleDownloadPDF = async () => {
        setIsLoading(true)

        postApi("Report/export-income-expense-report", {
            fromDate: date[0] ? dateFormat(
                date[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: date[1] ? dateFormat(
                date[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
        }).then(({ data, status }) => {
            if (status === 200) {
                const byteCharacters = atob(data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `Income_Expense_Report.pdf`;

                link.click();

                window.URL.revokeObjectURL(link.href);
                setIsLoading(false)
            } else {
                setIsLoading(false)
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })


        // var myHeaders = new Headers();
        // myHeaders.append("accept", "*/*");
        // myHeaders.append("Content-Type", "application/json")
        // myHeaders.append("Authorization", `Bearer ${JSON.parse(localStorage.getItem("authUser")).Token}`);
        // const raw = {
        //     fromDate: date[0] ? dateFormat(
        //         date[0],
        //         "yyyy-MM-dd"
        //     ) : new Date().toISOString().slice(0, 10),
        //     toDate: date[1] ? dateFormat(
        //         date[1],
        //         "yyyy-MM-dd"
        //     ) : new Date().toISOString().slice(0, 10),
        // }
        // var requestOptions = {
        //     method: 'POST',
        //     headers: myHeaders,
        //     body: JSON.stringify(raw),
        //     redirect: 'follow'
        // };

        // fetch(`${appConfig.BASE_URL}/Report/export-income-expense-report`,
        //     requestOptions
        // )
        //     .then(response => response.text())
        //     .then(response => {
        //         const byteCharacters = atob(response);
        //         const byteNumbers = new Array(byteCharacters.length);
        //         for (let i = 0; i < byteCharacters.length; i++) {
        //             byteNumbers[i] = byteCharacters.charCodeAt(i);
        //         }
        //         const byteArray = new Uint8Array(byteNumbers);
        //         const blob = new Blob([byteArray], { type: 'application/pdf' });

        //         const link = document.createElement('a');
        //         link.href = window.URL.createObjectURL(blob);
        //         link.download = `Income_Expense_Report.pdf`;

        //         link.click();

        //         window.URL.revokeObjectURL(link.href);
        //         setIsLoading(false)

        //     })
        //     .catch(error => setIsLoading(false));
    }

    // header & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Date",
                accessor: "Date",
                width: "6%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.Name == '' ? ""
                            : dateFormat(
                                row.original.Date.split("T")[0],
                                "dd/MM/yyyy"
                            )}
                    </p>
                ),
            },
            {
                Header: "Name",
                accessor: "Name",
                width: "7%",
                Cell: ({ row }) => (
                    <p
                        className=" mb-0 text-wrap"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={`${row.original.Name}`}
                    >
                        {/* {row.original.Name?.length > 10
                            ? `${row.original.Name.substr(0, 10)}...`
                            : row.original.Name == ""
                                ? "N/A"
                                : row.original.Name} */}
                        {row.original.Name == '' ? "" : row.original.Name}
                    </p>
                ),
            },
            {
                Header: "Details",
                accessor: "Details",
                Cell: ({ row }) => (
                    <p
                        className=" mb-0 text-wrap"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={`${row.original.Details == null ? '' : row.original.Details}`}
                    >
                        {row.original.Details == ""
                            ? ""
                            : row.original.Details}
                        {/* {row.original.Details?.length > 13
                            ? `${row.original.Details.substr(0, 13)}...`
                            : row.original.Details == ""
                                ? "N/A"
                                : row.original.Details} */}
                    </p>
                ),
            },
            {
                Header: "Mode",
                accessor: "PaymentMode",
                width: "4%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.PaymentMode == 1
                            ? "Cash"
                            : row.original.PaymentMode == 2
                                ? "Bank" : ''}
                    </p>
                ),
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}
                    >
                        Amount
                    </div>
                ),
                accessor: "Amount",
                textAline: "end",
                borderRight: "1px solid #959595b0",
                // width: "13%",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div style={{
                                display: "flex",
                                alignItems: "end",
                                justifyContent: "end",
                                textAlign: "end"
                            }}
                            >
                                {row.original.Name ?
                                    <>
                                        <i className="mdi mdi-currency-inr"></i>
                                        {new Intl.NumberFormat('en-IN', {
                                            currency: 'INR',
                                            minimumFractionDigits: 2,
                                        }).format(row?.original?.Amount || 0)}</>
                                    : ""}

                            </div>
                        </>

                    )
                },
            },
            {
                Header: "Date",
                accessor: "ExpenseDate",
                width: "6%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.ExpenseName == ""
                            ? ""
                            : dateFormat(
                                row.original.ExpenseDate?.split("T")[0],
                                "dd/MM/yyyy"
                            )}
                    </p>
                ),
            },
            {
                Header: "Name",
                accessor: "ExpenseName",
                width: "7%",
                Cell: ({ row }) => (
                    <p
                        className=" mb-0 text-wrap"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={`${row.original.ExpenseName}`}
                    >
                        {/* {row.original.ExpenseName?.length > 10
                            ? `${row.original.ExpenseName.substr(0, 10)}...`
                            : row.original.ExpenseName == ""
                                ? "N/A"
                                : row.original.ExpenseName} */}
                        {row.original.ExpenseName == ""
                            ? ""
                            : row.original.ExpenseName}
                    </p>
                ),
            },
            {
                Header: "Details",
                accessor: "ExpenseDetails",
                Cell: ({ row }) => (
                    <p
                        className=" mb-0 text-wrap"
                        // style={{width:"120px"}}
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={`${row.original.ExpenseDetails == null ?
                            '' : row.original.ExpenseDetails}`}

                    >
                        {row.original.ExpenseDetails == ""
                            ? ""
                            : row.original.ExpenseDetails}
                        {/* {row.original.ExpenseDetails?.length > 15
                            ? `${row.original.ExpenseDetails.substr(0, 15)}...`
                            : row.original.ExpenseDetails == ""
                                ? ""
                                : row.original.ExpenseDetails} */}
                    </p>
                ),
            },
            {
                Header: "Mode",
                accessor: "ExpensePaymentMode",
                width: "4%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.ExpensePaymentMode == 1
                            ? "Cash"
                            : row.original.ExpensePaymentMode == 2
                                ? "Bank" : ''}
                    </p>
                ),
            },
            {
                Header: "Amount",
                accessor: "ExpenseAmount",
                textAline: "end",
                // width: "13%",
                Cell: ({ row }) => {
                    return (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "end",
                                justifyContent: "end",
                                textAlign: "end"
                            }}
                        >
                            {
                                row?.original?.ExpenseName ? (
                                    <>
                                        <i className="mdi mdi-currency-inr"></i><>
                                            {new Intl.NumberFormat('en-IN', {
                                                currency: 'INR',
                                                minimumFractionDigits: 2,
                                            }).format(row?.original?.ExpenseAmount || 0)}</>
                                    </>
                                ) : ("")
                            }
                        </div>
                    )
                },
            },
        ],
        [selectedOptions]
    )

    return (
        <div className="page-content">
            <div className="container-fluid">
                {isLoading && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].title}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                />
                <Card>
                    <CardBody>
                        <Row>
                            <Col md={10}>
                                <Row>
                                    <Col md={isIpad ? 12 : 5} className={`${isMobile ? 'serchButton' : 'serchButtonMargin'} mb-2 `}   >
                                        <Select
                                            defaultValue={[]}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            onChange={(options) => {
                                                if (Array.isArray(options)) {
                                                    setSelectedOptions(options.map((opt) => opt.value));
                                                }
                                            }}
                                            options={allOptions}
                                            components={{
                                                Option: InputOption,
                                            }}
                                            placeholder="Hide columns"
                                            styles={selectStyles}
                                        />
                                    </Col>
                                    <Col md={4} className="table-header" >
                                        <div className=" d-flex">
                                            <Flatpickr
                                                ref={flatpickrRef}
                                                className="form-control d-block"
                                                placeholder="dd M,yyyy"
                                                options={{
                                                    mode: "range",
                                                    dateFormat: "d-m-Y"
                                                }}
                                                value={date}
                                                onChange={(e) => { setdate(e) }}

                                            />
                                            <i
                                                className="fas fa-calendar-alt calander-icon"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    flatpickrRef.current.flatpickr.open();
                                                }}
                                            ></i>
                                        </div>
                                    </Col>
                                    <Col md={isIpad ? 3 : 2} className="table-header mb-2" >
                                        <div className={`${isMobile ? 'serchButton' : 'serchButtonMargin'} mb-2 `}>
                                            {isLoadiButtonng ? (
                                                <button type="button" className="btn btn-primary">
                                                    <i className="bx bx-hourglass bx-spin font-size-13 align-middle me-1"></i>
                                                    Loading
                                                </button>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary "
                                                    onClick={() => {
                                                        incomeExoenseApi()
                                                    }}
                                                >
                                                    <i className="bx bx-search-alt font-size-16 align-middle me-2"></i>
                                                    Search
                                                </button>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={2} className={`${isMobile ? 'serchButton' : 'serchButtonMargin'} table-header mb-2 `} style={{ textAlign: "end" }}>
                                {/* <Row>
                                    
                                    <Col md="12" className="table-header">
                                        {IncomeData.length > 0 ? (<button
                                            type="button"
                                            className="btn btn-excel btn-label1"
                                            onClick={writeDataToExcel}
                                        >
                                            Export <i className="far fa-file-excel label-icon1"></i>
                                        </button>) : (<button
                                            type="button"
                                            className="btn btn-excel btn-label1"
                                            style={{ cursor: "not-allowed" }}
                                        >
                                            Export <i className="far fa-file-excel label-icon1"></i>
                                        </button>)}
                                    </Col>
                                </Row> */}

                                <div className="d-flex" style={{ justifyContent: isMobile ? "start" : "end", gap: "15px" }}>
                                    <div>
                                        {IncomeData.length > 0 ? (<button
                                            type="button"
                                            className="btn btn-pdf  btn-label1"
                                            onClick={handleDownloadPDF}
                                        >
                                            Export <i className="far fa-file-pdf label-icon1"></i>
                                        </button>) :
                                            (<button
                                                type="button"
                                                className="btn btn-pdf  btn-label1"
                                                style={{ cursor: "not-allowed" }}
                                            >
                                                Export <i className="far fa-file-pdf label-icon1"></i>
                                            </button>)
                                        }

                                    </div>
                                </div>


                            </Col>

                        </Row>
                        <Row>
                            <Col md={12}>
                                <IncomeExpenceTable
                                    columns={columns}
                                    data={IncomeData}
                                    isLoading={isLoading}
                                    totalIncome={totalIncome}
                                    totalExpense={totalExpense}
                                    selectedOptions={selectedOptions}
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        </div >
    )
}

export default IncomExpense

